import React from 'react'
import './nav.css'
import {FaHome} from 'react-icons/fa'
import {RiFolderUserFill} from 'react-icons/ri'
import {BsFillFileEarmarkBarGraphFill} from 'react-icons/bs'
import {SiMinutemailer} from 'react-icons/si'
import {MdWork} from 'react-icons/md'
import { useState } from 'react'



const Nav = () => {
  const [activeNav, setActiveNav] = useState('#')
  return (
    <nav>
      <a href='#' onClick={() => setActiveNav('#')} className={activeNav === '#' ? 'active' : ''}><FaHome/></a>
      <a href='#about' onClick={() => setActiveNav('#about')} className={activeNav === '#about' ? 'active' : '' }><RiFolderUserFill/></a>
      <a href='#experience' onClick={() => setActiveNav('#experience')} className={activeNav === '#experience' ? 'active' : '' }><BsFillFileEarmarkBarGraphFill/></a>
      <a href='#portfolio' onClick={() => setActiveNav('#portfolio')} className={activeNav === '#portfolio' ? 'active' : '' }><MdWork/></a>
      <a href='#contact' onClick={() => setActiveNav('#contact')} className={activeNav === '#contact' ? 'active' : '' }><SiMinutemailer/></a>
    </nav>
  )
}

export default Nav